import React from 'react';
import { Box, Button, Skeleton, Stack, Typography } from '@mui/material';

type ReportHeaderSectionProps = {
  isLoadingData: boolean;
  shouldShowCompanyNameImmediately: boolean;
  resolvedCompanyName: string;
  canSwitchCompany: boolean;
  canManageSpirisConnections?: boolean;
  onSwitchCompany: () => void;
  onManageSpirisConnections?: () => void;
};

const ReportHeaderSection: React.FC<ReportHeaderSectionProps> = ({
  isLoadingData,
  shouldShowCompanyNameImmediately,
  resolvedCompanyName,
  canSwitchCompany,
  canManageSpirisConnections = false,
  onSwitchCompany,
  onManageSpirisConnections,
}) => {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      alignItems={{ xs: 'flex-start', sm: 'center' }}
      justifyContent="space-between"
      sx={{ mb: 3 }}
    >
      <Box>
        <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
          Bolag
        </Typography>
        {isLoadingData && !shouldShowCompanyNameImmediately ? (
          <Skeleton variant="text" width={320} height={32} />
        ) : (
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {resolvedCompanyName}
          </Typography>
        )}
      </Box>
      <Stack direction="row" spacing={1}>
        {canSwitchCompany && (
          <Button variant="contained" onClick={onSwitchCompany}>
            Byt bolag
          </Button>
        )}
        {canManageSpirisConnections && onManageSpirisConnections && (
          <Button variant="contained" onClick={onManageSpirisConnections}>
            Spiris-kopplingar
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

export default React.memo(ReportHeaderSection);
